import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/logowanie',
    component: () => import('../../layouts/AdminAuthLayout.vue'),
    children: [
      {
        path: ':redirect?',
        component: () => import('pages/admin/auth/Login.vue'),
        name: 'login',
        meta: {
          header: 'Zaloguj się',
          subheader: 'Zaloguj się do swojego konta Administratora.',
        },
      },
      {
        path: 'resetuj-haslo',
        name: 'reset-password',
        component: () => import('pages/admin/auth/ResetPassword.vue'),
        meta: {
          header: 'Resetuj hasło',
          subheader:
            'Wpisz adres e-mail na który wyślemy Ci link do resetu hasła.',
        },
      },
      {
        path: 'nowe-haslo/:token',
        name: 'new-password',
        component: () => import('pages/admin/auth/SetNewPassword.vue'),
        meta: {
          header: 'Utwórz nowe hasło',
          subheader:
            'Hasło musi zawierać minimum jedną dużą, jedną małą literę, cyfrę oraz znak specjalny.',
        },
      },
    ],
    meta: {
      title: 'Logowanie',
    },
  },
  {
    path: '/strona-glowna',
    component: () => import('layouts/UserLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/admin/user/Dashboard.vue'),
        name: 'home',
      },
    ],
    meta: {
      title: 'Strona główna',
      requiresAuth: true,
    },
  },
  {
    path: '/wizyty',
    component: () => import('layouts/UserLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/admin/user/Appointments.vue'),
        name: 'appointments',
      },
      {
        path: 'szczegoly/:id',
        component: () => import('pages/admin/user/AppointmentDetails.vue'),
        name: 'appointment-details',
      },
    ],
    meta: {
      title: 'Lista wizyt',
      requiresAuth: true,
    },
  },
  {
    path: '/testy-wysylkowe',
    component: () => import('layouts/UserLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/admin/user/ShipmentTests.vue'),
        name: 'shipment',
      },
      {
        path: 'szczegoly/:id',
        component: () => import('pages/admin/user/ShipmentTestDetails.vue'),
        name: 'shipment-details',
      },
    ],
    meta: {
      title: 'Testy wysyłkowe',
      requiresAuth: true,
    },
  },
  {
    path: '/zamowienia',
    component: () => import('layouts/UserLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/admin/user/Orders.vue'),
        name: 'orders',
      },
      {
        path: 'szczegoly/:id',
        component: () => import('pages/admin/user/OrderDetails.vue'),
        name: 'order-details',
      },
    ],
    meta: {
      title: 'Lista zamówień',
      requiresAuth: true,
    },
  },
  {
    path: '/partnerzy',
    component: () => import('layouts/UserLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/admin/user/Laboratories.vue'),
        name: 'laboratories',
      },
      {
        path: 'szczegoly/:id',
        component: () => import('pages/admin/user/LaboratoryDetails.vue'),
        name: 'laboratory-details',
      },
      {
        path: 'punkt-pobran/:id',
        component: () => import('components/pages/samplingPoint/SamplingPointDetails.vue'),
        name: 'sampling-point-details'
      },
    ],
    meta: {
      title: 'Lista partnerów medycznych',
      requiresAuth: true,
    },
  },
  {
    path: '/badania',
    component: () => import('layouts/UserLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/admin/user/Examinations.vue'),
        name: 'examinations',
      },
      {
        path: 'szczegoly/:id/:labId?',
        component: () => import('pages/admin/user/ExaminationDetails.vue'),
        name: 'examination-details',
      },
    ],
    meta: {
      title: 'Lista badań',
      requiresAuth: true,
    },
  },
  {
    path: '/pacjenci',
    component: () => import('layouts/UserLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/admin/user/Patients.vue'),
        name: 'patients',
      },
      {
        path: 'szczegoly/:patientId',
        component: () => import('pages/admin/user/PatientDetails.vue'),
        name: 'patient-details',
      },
    ],
    meta: {
      title: 'Lista pacjentów',
      requiresAuth: true,
    },
  },
  {
    path: '/oauth2/furgonetka/callback',
    meta: {
      title: 'Potwierdzenie autoryzacji mapy',
      requiresAuth: true,
    },
    redirect: to => {
      return {
        name: 'home',
        query: { code: to.query.code }
      }
    }
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'login' },
    meta: {
      title: '404',
    },
  },
]

export default routes
